import { createSelector } from 'reselect'
import { DefaultTopicMediaPlanState } from '../reducers/topicMediaPlan_reducer'

const getTopicMediaPlan = (state, props) => {
  let topicId = null
  if (props.shortcut && props.shortcut.target_id) {
    topicId = props.shortcut.target_id
  } else {
    topicId = props.match.params.topicId
  }
  return (state.topics.byId[topicId] || {}).mediaPlan
}

const getTopicMediaPlanState = createSelector(
  [getTopicMediaPlan],
  (mediaPlan) => {
    return mediaPlan || DefaultTopicMediaPlanState
  }
)

const makeTopicMediaPlan = () => {
  return createSelector(
    [getTopicMediaPlanState],
    (mediaPlan) => {
      return {
        isFetching: mediaPlan.isFetching || mediaPlan.didInvalidate || !mediaPlan.details,
        error: mediaPlan.error,
        details: mediaPlan.details
      }
    }
  )
}

export { makeTopicMediaPlan }